import ImpressionsContainer from '@components/Analytics/ImpressionsContainer'
import BasicTableGrid from '@components/BasicTableGrid';
import DistributionBar from '@components/Analytics/DistributionBar'
import FilterDate  from '@components/FilterDate';
import FilterIcon from '@assets/common/filter.png';
import DownIcon from '@assets/common/dropDown.png';
import { AgChartsReact } from 'ag-charts-react';
import PopUp from '@components/PopUp';
import SelectionPopUp from '@components/SelectionPopUp';
import PaymentGatewayDetails from '@components/Analytics/PaymentGatewayDetails';
import moment from 'moment';

const viewOption = [{_id:'Line', name:'Line'},
    {_id:'Bar', name:'Bar'}
    ]
function LeadsView(props){
    
    return <div className='AdminPageMainContainer bg-white d-flex gap-3 p-4 overflow-scroll'  style={{height:'100%'}}>

              <div className=" d-flex gap-2">
                    <div className='border rounded p-2 d-flex justify-content-center align-items-center' style={{height:'32px'}}
                        onClick={(e)=>props.handlePopUpOpen(e, 'dateSelectPopUp')}
                    >
                        <img style={{height: '15px'}} src={FilterIcon}/>
                    </div> 
                    <div className='filterSelect'><FilterDate title="Start Date" value={props.startDate} 
                    onChange={(event)=>{props.handleChange('startDate', event.target.value)}}/></div>
                    <div className='filterSelect'><FilterDate title="End Date" value={props.endDate} 
                    onChange={(event)=>{props.handleChange('endDate', event.target.value)}} /></div>
                    <div className='filterSelect' style={{cursor:'pointer'}}
                              onClick={(e)=>props.handlePopUpOpen(e,"viewByPopUp")}>
                            {props.chartType} <img src={DownIcon} style={{height:'7px'}}/></div>
                </div>
                <div className="d-flex flex-column gap-2">
                    <div className="row mx-1" style={{height: '500px'}}>
                             
                            <div className={"col-12 border rounded p-0"}>
                            {(props.isLoading)?
                            <div className='w-100 h-100 d-flex'>

                                <div className="spinner-border text-danger m-auto" role="status">
                                <span className="visually-hidden">Loading...</span>
                                </div> 
                            </div>
                            :
                            <div className=' pb-4' style={props.viewGraphBy=='Views'?{height:'87%', justifyContent:'flex-end'}:{height:'100%'}}>
                                    <AgChartsReact 
                                        options={props.chartType === "Line" ? props.chartOptions : props.chartOptions2} 
                                        />
                            </div>
                            }
                        </div>

                            
                    </div>
                    <div className="d-flex" style={{height: '400px'}}>
                                        
                        <BasicTableGrid 
                            gridId='AnalyticsOverview'
                            data={props.deferredData} // Data to be displayed
                            fixedCols={2} // How many columns are fixed and not scrolling
                            initialSize = {[35,499,183,258,150,133,262]}
                            initialSorting={[{"id": "Date Added","desc": false}]}
                            handleSelect={(selectedRows) => {
                                props.handleCheckBoxes(selectedRows);
                            }}
                            length={20}
                            onSortChange={(data) => {}
                                // props.handleSort(data)
                            }
                            columnsOptionPopUpRef={props.columnsOptionPopUpRef}
                            isColorEnabled={true}
                            isNavigationHidden={true}
                            columns={[
                            {header: "Geography",
                                cell: (data) => {
                                const info = data.row.original;
                                return (<div className="d-flex gap-2">
                                            <div className="d-flex flex-column justify-content-center gap-2 ms-2">
                                                <div>{info?.country? info.country : "Other"} </div>
                                            </div>
                                        </div>);
                                },
                            },
                            {header: 'Views', 
                            cell: (data) => {
                                const info = data.row.original;
                                return <div>{info.pageViews}</div>}
                            },
                            {header: 'Unique Views', 
                            cell: (data) => {
                                const info = data.row.original;
                                return <div>{info.uniquePageViews}</div>}
                            },
                            {header: 'Sign-ups', 
                            cell: (data) => {
                                const info = data.row.original;
                                return <div>{info.leadSignUps}</div>}
                            },
                            {header: 'Conversions', 
                            cell: (data) => {
                                const info = data.row.original;
                                return <div>{info.leadConversions}</div>}
                            },
                            {header: 'Unique Leads to conversion rate', 
                            cell: (data) => {
                                const info = data.row.original;
                                return <div>{info.leadConversionRate}</div>}
                            },
                            {header: 'Revenue generated', 
                            cell: (data) => {
                                const info = data.row.original;
                                return <div>{"Rs."} {info.revenueFromLead}</div>}
                            },                        
                            ]}

                        />
                </div>
                </div>
                {props.popUp === "dateSelectPopUp"  &&<PopUp visible={props.isPopUpVisible}
				top={180}
				left={280}
				handleOutSideClick={props.handlePopUpClose}>
				<div style={{height: 'auto', overflow:'hidden'}}>
					{props.mainDateOption.map((option, index) => (
						<div
							key={index}
							onClick={(e) => option !=='Select' ?props.handlePopUpSave(e, option):props.handlePopUpOpen(e, 'dateYearPopUp')}
							className='settingOption d-flex'>
							{option}
							<img className='ms-auto' src={option.img} style={{height:'12px'}}/>
						</div>
					))}
				</div>
                </PopUp>}
                {props.popUp === "dateYearPopUp"  &&<PopUp visible={props.isPopUpVisible}
                    top={180}
                    left={280}
                    handleOutSideClick={props.handlePopUpClose}>
                    <div style={{height: 'auto', overflow:'hidden'}}>
                        {props.years.map((option, index) => (
                            <div
                                key={index}
                                onClick={(e) => props.handlePopUpOpen(e, 'dateMonthPopUp', option)}
                                className='settingOption d-flex'>
                                {option}
                                <img className='ms-auto' src={option.img} style={{height:'12px'}}/>
                            </div>
                        ))}
                    </div>
                </PopUp>}
                {props.popUp === "dateMonthPopUp"  &&<PopUp visible={props.isPopUpVisible}
                    top={180}
                    left={280}
                    handleOutSideClick={props.handlePopUpClose}>
                    <div style={{height: 'auto', overflow:'hidden'}}>
                        {props.months.map((option, index) => (
                            <div
                                key={index}
                                onClick={(e) => props.handlePopUpSave(e, index)}
                                className='settingOption d-flex'>
                                {option}
                                <img className='ms-auto' src={option.img} style={{height:'12px'}}/>
                            </div>
                        ))}
                    </div>
                </PopUp>}

                {props.popUp === "viewByPopUp"  &&<PopUp visible={props.isPopUpVisible}
				top={210}
				left={610}
				handleOutSideClick={props.handlePopUpClose}>
				<SelectionPopUp 
				  data = {viewOption}
				  optionKey= {"name"}
				  title={"Select graph type"}
				  searchPlaceholder={""}
				  isSearchEnabled={false}
				  height= {"auto"}
				  width= {"auto"}
				//   selectedItems={viewOption.filter(item => props.selectedViewOption?.id ===item._id)}
				  dataKey={"_id"}
				  selectedItemsKey={"_id"}
				  selectionType={"single"}
				  handleCancel ={props.handlePopUpClose}
				  handleSave={props.handlePopUpSave}/>
			</PopUp>}
    </div>
}

export default LeadsView